enum ModalTypes {
    PAIRING_GUIDE_ERROR,
    HID_RECONNECT,
    DEVICE_IS_IN_SBL,
    RECONNECT_DEVICE_GUIDE,
    FWU_LED_CHECK,
    FWU_ADDITIONAL_STEPS_GUIDE,
    FWU_ERROR,
    USB_REQUIRED,
}

export default ModalTypes;
